<template>
    <article class="section-item _cart-item">
        <div class="table-responsive">
            <table class="table cart-item--content">
                <thead class="cart-item--content--heading">
                <tr class="cart-item--content--element">
                    <th scope="col" class="cart-item--content--element--label">{{ $t('pages.checkout.print_section_column_item') }}</th>
                    <th scope="col" class="cart-item--content--element--label">{{ $t('pages.checkout.print_section_column_price_cad') }}</th>
                    <th scope="col" class="cart-item--content--element--label">{{ $t('pages.checkout.print_section_column_quantity') }}</th>
                    <th scope="col" class="cart-item--content--element--label">{{ $t('pages.checkout.print_section_column_price') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="cart-item--content--element" v-for="(item, photoId) in productItems" :key="photoId">
                    <td class="two-element">
                        <div class="cart-item--content--element--media" :style="{'background-image': 'url(' + photos[photoId].image_url + ')' }">
                        </div>
                        <div class="cart-item--content--element--heading">
                            <div class="cart-item--content--element--heading--title">{{ item.pica_service.event_name }}</div>
                            <div class="cart-item--content--element--heading--subtitle">{{ item.pica_service.event_start_at|formatDate }}</div>
                            <div class="cart-item--content--element--heading--remove">
                                <a href="" @click.prevent="$emit('remove-product-item', photoId)"
                                   v-b-tooltip.hover :title="$t('pages.configure_product.action_remove_photo')">
                                    {{ $t('pages.checkout.print_amount_remove_items') }}
                                </a>
                            </div>
                        </div>
                    </td>
                    <td>{{ item.price_unit_formatted }}</td>
                    <td>
                        <div class="cart-item--content--element--spinner">
                            <div class="cart-item--content--element--spinner--down"
                                 v-b-tooltip.hover :title="$t('pages.configure_product.action_decrement_quantity')">
                                <button @click="$emit('decrement-quantity', photoId)" data-dir="dwn"></button>
                            </div>
                            <input type="text" class="form-control text-center"
                                   v-model="productItems[photoId].quantity">
                            <div class="cart-item--content--element--spinner--up"
                                 v-b-tooltip.hover :title="$t('pages.configure_product.action_increment_quantity')">
                                <button @click="$emit('increment-quantity', photoId)" data-dir="up"></button>
                            </div>
                        </div>
                    </td>
                    <td>{{ item.price_formatted }}</td>
                </tr>
                </tbody>

                <tfoot class="cart-item--content--footer">
                <tr>
                    <th class="cart-item--content--footer--amount" scope="row" colspan="4">
                        {{ $t('pages.configure_product.items_total') }} {{ priceTotal|currency }}
                    </th>
                </tr>
                </tfoot>
            </table>
        </div>
    </article>
</template>


<script>
    export default {
        props: ['productItems', 'photos'],

        computed: {
            priceTotal() {
                let total = 0
                for (const photoId in this.productItems) {
                    let photo = this.productItems[photoId]
                    total += photo.price
                }
                return total
            },
        }
    }
</script>
